import { Building20Regular, Code20Regular, Rocket20Regular } from '@/components/Icon'

/**
 * Personas that predate the department list and are no longer offered in the
 * menu, but are still named by recorded demo scripts (`askBarPersonaId:
 * 'architect'`). Resolvable so playback keeps showing the label its narration
 * refers to; without this a stored id would silently fall back to Marketing
 * and the pill would contradict the transcript beside it.
 *
 * @type {{ value: string, label: string, Icon: import('react').ComponentType }[]}
 */
export const HOME_PERSONA_LEGACY_OPTIONS = [
  { value: 'founder', label: 'Founder', Icon: Rocket20Regular },
  { value: 'architect', label: 'Architect', Icon: Building20Regular },
  { value: 'swe', label: 'SWE', Icon: Code20Regular },
]
